import { identityApiVersion } from "@istari-frontend/auth";

// The SDK defaults to v2 when unset, so v1 and identity-off pass "v1" explicitly.
export function identityClientOptions(): { identityApiVersion: "v1" | "v2" } {
  return { identityApiVersion: identityApiVersion() };
}
